import { Printer } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Print whatever is on screen. No report generation, no waiting, the page as it
 * stands, with the app chrome stripped and collapsed sections opened by print CSS.
 */
export const PrintButton = () => (
  <button
    onClick={() => window.print()}
    data-testid="print-page-btn"
    title="Print this page"
    className="group inline-flex items-center gap-1.5 text-[11px] text-slate-300 hover:text-cyan-300
               border border-white/10 hover:border-cyan-300/40 rounded-full px-2.5 py-1
               transition-colors duration-200">
    <Printer className="w-3 h-3" />
    <span className="hidden sm:inline">Print this page</span>
  </button>
);

/** Sits at the top of every printout: who it is about, and when it was printed. */
export const PrintHeader = () => {
  const { user } = useAuth();
  const when = new Date().toLocaleDateString(undefined,
    { day: 'numeric', month: 'long', year: 'numeric' });
  return (
    <div className="print-only" style={{ marginBottom: '16px' }}>
      <div className="fp-print-head" style={{
        background: 'linear-gradient(90deg, #0891b2 0%, #0369a1 55%, #4f46e5 100%)',
        color: '#fff', borderRadius: '10px', padding: '10px 14px',
        display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '12px',
      }}>
        <span style={{ fontSize: '15px', fontWeight: 800, letterSpacing: '-0.01em', color: '#fff' }}>
          AGENTIC FUTUREPATH <span className="fp-print-accent">AI</span>
        </span>
        <span style={{ fontSize: '10.5px', color: '#e0f2fe' }}>
          {user?.full_name ? `${user.full_name} · ` : ''}Printed {when}
        </span>
      </div>
      <div className="fp-print-rule" style={{ height: '3px', marginTop: '5px', borderRadius: '3px',
        background: 'linear-gradient(90deg, #22d3ee, #6366f1 70%, transparent)' }} />
    </div>
  );
};

export default PrintButton;
